import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import Particles from "particles.vue";
import VueScrollTo from 'vue-scrollto';
import VueGtag from "vue-gtag";

Vue.use(VueAxios, axios)
Vue.use(Particles);
Vue.use(VueScrollTo);
Vue.use(VueGtag, {
  config: { id: "G-WHE32XLLDK" }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
